<template>
  <div class="number-input">
    <Button
      class="decrement-button"
      @click="decrement"
      type="icon"
      icon="icon icon-minus"
      size="medium"
      data-test="decrement_item_button"
    />
    <input
      class="el-input__inner number-input__field"
      :value="formattedValue"
      @input="handleInput"
      @blur="handleBlur"
      type="text"
      inputmode="decimal"
      data-test="line_quantity"
    >
    <Button
      class="increment-button"
      @click="increment"
      type="icon"
      icon="icon icon-add-3"
      size="medium"
      data-test="increment_item_button"
    />
  </div>
</template>

<script>
import { getNumberSeparators } from '~/lib/formatNumber';
import Button from './Button.vue';

export default {
  components: {
    Button,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isEditing: false,
      editingValue: '',
    };
  },
  computed: {
    locale() {
      return this.$i18n?.locale || 'cs';
    },

    separators() {
      return getNumberSeparators(this.locale);
    },

    formattedValue() {
      if (this.isEditing) {
        return this.editingValue;
      }
      return this.formatForDisplay(this.value);
    },
  },
  methods: {
    formatForDisplay(number) {
      if (number === null || number === undefined) return '';
      // Use Czech decimal separator as fallback
      const decimalSeparator = this.separators?.decimalSeparator || ',';
      return String(number).replace('.', decimalSeparator);
    },

    parseInput(input) {
      if (!input || input.trim() === '') return 0;
      // Use Czech decimal separator as fallback
      const decimalSeparator = this.separators?.decimalSeparator || ',';
      const normalized = input.replace(decimalSeparator, '.');
      const parsed = parseFloat(normalized);
      return Number.isNaN(parsed) ? 0 : parsed;
    },

    constrainValue(value) {
      return Math.max(this.min, Math.min(this.max, value));
    },

    emitValue(newValue) {
      const constrained = this.constrainValue(newValue);
      if (constrained !== this.value) {
        this.$emit('input', constrained);
      }
    },

    increment() {
      this.emitValue(this.value + this.step);
    },

    decrement() {
      this.emitValue(this.value - this.step);
    },

    handleInput(event) {
      this.isEditing = true;
      this.editingValue = event.target.value;
    },

    handleBlur() {
      this.isEditing = false;
      const parsed = this.parseInput(this.editingValue);
      this.emitValue(parsed);
    },
  },
};
</script>

<style lang="scss">
.number-input {
  .number-input__field {
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
    text-align: center;
  }

  .increment-button {
    position: absolute;
    top: 50%;
    right: .8em;
    transform: translateY(-50%);
  }

  .decrement-button {
    position: absolute;
    top: 50%;
    left: .8rem;
    transform: translateY(-50%);
  }

  .decrement-button, .increment-button {
    &:hover {
      transform: translateY(-50%) scale(1.1);
    }

    .icon {
      font-size: 1.3rem;
    }
  }
}
</style>
